import React from "react";

const TextBold = ({
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <span
      className="font-spaceGrotesk flex justify-center text-center text-lg font-bold"
      {...props}
    >
      {children}
    </span>
  );
};

export default TextBold;
